import "objectFitPolyfill";

const ObjectFitPlugin = {
  install(Vue) {
    Vue.directive("object-fit", {
      bind: el => {
        window.objectFitPolyfill(el);
      }
    });
  }
};

export default ObjectFitPlugin;
